<template>
    <div class="adverts-in-search" v-if="advert">
        <a rel="sponsored" target="_blank" :href="advert.link"
           @click="captureTrackingEvent(currentUser, 'search', 'banner-click', advert.bq_tag)"
        >
            <picture>
                <source media="(min-width: 769px)" :srcset="advert.img_desktop" width="888" height="266">
                <img class="w-100 h-100" width="510" height="340" :src="advert.img_mobile" :alt="advert.alt_text || ''">
            </picture>
        </a>
    </div>
</template>

<script>
import userMixin from "@/components/mixins/userMixin";
import urlMixin from "@/components/mixins/url-mixin";
import xtrackingMixin from '@/components/mixins/xtrackingMixin';

export default {
    computed: {
        ...mapState(['translate', 'currentUser']),
    },
    watch: {},
    mixins: [
        userMixin,
        urlMixin,
        xtrackingMixin,
    ],
    props: {
        advert: {
            required: true,
        }
    },
}
</script>

